<script lang="ts">
  import { css, cx } from '@agapi/ui/panda/css';
  import { cardStyles } from '../card.styles';
  import { dynamicColorStyles, token } from '@agapi/ui/panda/utils';
  import { setContext } from 'svelte';
  import { useActions } from '../../../utils/useAction';
  import type { CardProps } from '../card.types';
  import type { Token } from '@agapi/ui/panda/tokens';

  const {
    use,
    colorVariant = 'default',
    css: cssProp, children,
    spacing = "tight",
    ...props
  }: CardProps = $props();

  const classes = cardStyles()

  setContext<{imageBg: boolean}>('card', {
    imageBg: false,
  })
</script>

<div
  class={cx(classes.root, css(cssProp))}
  use:useActions={use ?? []}
  {...props}
  style="
    --contentPadding: {token(`spacing.${spacing}` as Token)};
    {colorVariant === 'transparent' ? '' : `background-color: ${dynamicColorStyles(colorVariant).backgroundColor};`}
    {colorVariant === 'transparent' ? '' : `color: ${dynamicColorStyles(colorVariant).color};`}
  ">
  {#if children}
    {@render children()}
  {/if}
</div>
